import { render, staticRenderFns } from "./UserQualificationChangeActivationType.vue?vue&type=template&id=ec10a868&"
import script from "./UserQualificationChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserQualificationChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports